/**
 * [AI補完仕様] このコメントはAI補完（コード自動生成）に構造情報として渡されます。変更時は実装品質に直結するため正確に保つこと。
 *
 * ワークフローステータス・アクションの表示用ヘルパー。
 *
 * @contract ステータス表示にはgetStatusLabel()を使うこと（ステータス文字列を直接表示しない）。
 * @contract CSSクラス付与にはgetStatusClass()を使うこと。
 * @contract 遷移アクション名の表示にはgetActionLabel()を使うこと（アクション文字列を直接表示しない）。
 * @contract ステータスが終端到達したかの判定にはisTerminalStatus()を使うこと。
 * @signature getStatusLabel(status: string): string
 * @signature getStatusClass(status: string): string
 * @signature getActionLabel(action: string): string
 * @signature isTerminalStatus(status: string): boolean
 */
const statusLabels: Record<string, string> = {

  'draft': '下書き',

  'pending_supervisor': '上司承認待ち',

  'approved': '承認済',

  'rejected': '差戻し',

  'deleted': '削除済',

}

const statusStyles: Record<string, string> = {

  'draft': 'status-neutral',

  'pending_supervisor': 'status-warning',

  'approved': 'status-success',

  'rejected': 'status-danger',

  'deleted': 'status-neutral',

}

const actionLabels: Record<string, string> = {

  'submit': '申請',

  'supervisor_approve': '承認',

  'supervisor_reject': '差戻し',

  'withdraw': '取り下げ',

  'resubmit': '再申請',

  'delete': '削除',

}

const terminalStatuses: Set<string> = new Set([

  'approved',

  'deleted',

])

export function getStatusLabel(status: string): string {
  return statusLabels[status] || status
}

export function getStatusClass(status: string): string {
  return statusStyles[status] || 'status-neutral'
}

export function isTerminalStatus(status: string): boolean {
  return terminalStatuses.has(status)
}

export function getActionLabel(action: string): string {
  return actionLabels[action] || action
}
